/**
 * Toggles the dedicated Apple Store pages: the Apple brand landing (`/marketplace/1032`),
 * Apple LOB pages (`/marketplace/category-apple/:id`) and the Apple secondary/tertiary nav.
 * When disabled, Apple is presented as a regular brand. Apple PDP is not affected.
 */
export const APPLE_STORE_PAGES_ENABLED = false;
